export default __webpack_public_path__ + "static/media/downArrow.54568561.svg";